import * as DAOUtils from "../utils/DAOUtils";
import * as ObjectUtils from "../utils/ObjectUtils";

export function getMyWorkListsById(listId) {
  return DAOUtils.get(`/worklists/${listId}`, {
    mock: "heroku",
  });
}

export function getMyWorkLists(location, medKeyType) {
  return DAOUtils.get(`/worklists?locationId=${location}&medKeyType=${medKeyType}`);
}

export function getTemplate() {
  return DAOUtils.get("/worklists/template");
}

export function getWorkListItemById(listId, itemId) {
  return DAOUtils.get(`/worklists/${listId}/items/${itemId}`);
}

export async function addPillsToWorkList(listId, pills, query) {
  const body = pills.map((p) => {
    return {
      id: p.id,
      amountOfCanisters: p.amountOfCanisters,
    };
  });
  let url = `/worklists/${listId}/items`;
  if (query) {
    url += "?query=" + query;
  }
  const responseItems = await DAOUtils.post(url, body, {
    mock: "heroku",
  });

  return responseItems.map((item) => ({
    worklistItemId: item.worklistItemId || item.workListItemId,
  }));
}

export function updatePillsOnWorkList(listId, pills, query) {
  const body = pills.map((p) => {
    return {
      id: p.worklistItemId || p.id,
      amountOfCanisters: p.amountOfCanisters,
    };
  });
  let url = `/worklists/${listId}/items`;
  if (query) {
    url += "?query=" + query;
  }
  return DAOUtils.put(url, body, {
    mock: "heroku",
  });
}

export function createPillsOnWorkList(listId, pills, query) {
  const body = pills.map((p) => {
    return {
      id: p.worklistItemId || p.id,
      amountOfCanisters: p.amountOfCanisters,
    };
  });
  let url = `/worklists/${listId}/items`;
  if (query) {
    url += "?query=" + query;
  }
  return DAOUtils.post(url, body, {
    mock: "heroku",
  });
}

export async function getCheckData(listId) {
  const items = await DAOUtils.get(`/worklists/${listId}/checkdata`, { mock: "heroku" });
  for (const item of items) {
    item.finalData = ObjectUtils.getSubobject(item, ["listItemId", "medicineName", "manufacturer"]);
    item.finalData.manufacturer = item.finalData.manufacturer || "";
    item.finalData.medicineName = item.finalData.medicineName || "";

    if (item.pillStatusId === "severalOptions") {
      item.finalData.severalOptionsView = "suggestions_screen";
    } else {
      item.finalData.uvSensibility = ObjectUtils.getProperty(
        item.matchDbData,
        "uvSensibility",
        item.userImportData.uvSensibility
      );
      item.finalData.shape = ObjectUtils.deepClone(item.userImportData.shape);
    }
  }
  return items;
}

export function getCheckDataSuggestions(listId, checkDataListItemId) {
  return DAOUtils.get(`/worklists/${listId}/checkdata/items/${checkDataListItemId}/suggestions`);
}

export function saveCheckData(listId, data) {
  return DAOUtils.post(`/worklists/${listId}/checkdata`, data);
}

export async function startExcelDownload(listId) {
  return DAOUtils.post(`/worklists/${listId}/downloadExcel`);
}

export async function getDownloadedExcel(listId, requestId) {
  return DAOUtils.get(`/worklists/${listId}/downloadExcel/${requestId}`);
}
